<template>
  <v-container>
    <v-card>
      <v-row>
        <v-col>
          <v-select
            label="Select Client"
            :items="clients"
            v-model="selected.client"
            noFilter
            :ripple="false"
            clearable
            hide-details
            clear-icon
            solo
            text
            class="red darken-3 my-3 mx-6"
          ></v-select>
        </v-col>
        <v-col>
          <v-autocomplete
            label="Brand"
            :items="results.brand"
            :search-input.sync="selected.brand"
            noFilter
            :ripple="false"
            clearable
            hide-details
            clear-icon
            item-text="value"
            item-value="id"
            solo
            text
            class="my-3 me-6"
          ></v-autocomplete>
        </v-col>
        <v-col>
          <v-autocomplete
            label="Name"
            :items="results.product"
            :search-input.sync="selected.product"
            item-text="value"
            item-value="id"
            noFilter
            clearable
            hide-details
            clear-icon
            solo
            text
            class="my-3 me-6"
          ></v-autocomplete>
        </v-col>
        <v-col>
          <v-autocomplete
            label="SKU"
            :items="results.sku"
            :search-input.sync="selected.sku"
            item-text="value"
            item-value="id"
            noFilter
            clearable
            hide-details
            clear-icon
            solo
            text
            class="my-3 me-6"
          ></v-autocomplete>
        </v-col>
        <v-col>
          <v-btn large class="mt-3 warning" @click="loadSecondProducts">Load</v-btn>
          <v-btn
            large
            class="mt-3 ms-1 primary"
            @click="moveUrls"
            :disabled="!selected_product.length"
            :loading="loading"
          >Move</v-btn>
        </v-col>
      </v-row>
    </v-card>
    <v-card class="mt-5">
      <v-card-title>
        <!-- <v-text-field
          v-model="searchFor"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field> -->
      </v-card-title>

      <v-data-table
        v-model="selected_product"
        :headers="headers"
        :items="products.filter(p => p.product_id !== my_product_id)"
        item-key="product_name"
        :search="searchFor"
        single-select
        show-select
        dense
        no-data-text="There are no Products yet"
        :loading="!products.length && loading"
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-spacer></v-spacer>
            <v-toolbar-title>Products</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-text-field
              label="Search"
              v-model="searchFor"
              class="pa-3"
              append-icon="mdi-magnify"
              single-line
              style="width: 40px"
            />
          </v-toolbar>
        </template>
      </v-data-table>
    </v-card>
    <!-- <v-btn
      bottom
      right
      fixed
    >Move To Product</v-btn> -->
  </v-container>
  <!-- <v-autocomplete
        :items="results.brand"
        :search-input.sync="selected.brand"
        noFilter
        :ripple="false"
        background-color="rgba(48, 127, 255, 0.1)"
        clearable
        hide-details
        clear-icon
        append-icon="expand_more"
        item-text="value"
        item-value="id"
        label="Brand"
        solo
        text
      /> -->
</template>

<script>
/* eslint-disable */
export default {
  name: "N_MoveUrls",
  //   props: ["items"],
  data() {
    return {
      selected: {
        client: "",
        brand: "",
        category: "",
        product: "",
        sku: "",
        ean: "",
      },
      results: {
        client: {},
        brand: [],
        category: [],
        product: [],
        sku: [],
        ean: [],
      },
      products: [],
      headers: [
        {
          text: "Brand",
          value: "product_brand.name",
        },
        {
          text: "Name",
          value: "product_name",
        },
      ],
      selected_product: [],
      searchFor: "",
    };
  },
  computed: {
    clients() {
      return this.$store.state.productionModule.clients_list;
    },
    selected_client() {
      return this.$store.state.productionModule.product_filter.selected_client;
    },
    selected_domains() {
      return this.$store.state.productionModule.product_filter.selected_domains;
    },
    selected_sellers() {
      return this.$store.state.productionModule.product_filter.selected_sellers;
    },
    selected_filter_product_status() {
      return this.$store.state.productionModule.product_filter.product_status;
    },
    my_product_id() {
      return this.$store.state.productionModule.selected_product.id;
    },
    loading: {
      get() {
        return this.$store.state.productionModule.loading;
      },
      set(value) {
        const data = { value, key: "loading" };
        this.$store.commit("productionModule/SET_PRODUCTION_STATE", data);
      },
    },
    selected_urls_of_product: {
      get() {
        return this.$store.state.productionModule.selected_urls_of_product;
      },
      set(value) {
        const data = { value, key: "selected_urls_of_product" };
        this.$store.commit("productionModule/SET_PRODUCTION_STATE", data);
      },
    },
  },
  methods: {
    loadSecondProducts() {
      if (this.$store.state.sidebarModule.isOpen) {
        this.$store.commit("sidebarModule/toggleSidebar");
      }
      this.loading = true;
      this.selected_product = [];
      this.products = [];
      // const reset_data = { value: [], key: "loaded_products" }; // reset state.loaded_products
      // this.$store.commit("productionModule/SET_PRODUCTION_STATE", reset_data); //SET_LOADED_PRODUCTS
      const data = {
        task: "getProductList",
        payload: {
          filters: {
            brandFilter: this.selected.brand,
            clientFilter: this.selected.client,
            domainFilter: this.selected_domains,
            eanFilter: this.selected.ean,
            nameFilter: this.selected.product,
            productStatus: this.selected_filter_product_status,
            sellerFilter: this.selected_sellers,
            skuFilter: this.selected.sku,
          },
        },
      };
      this.$store.dispatch("productionModule/general_api", data).then((res) => {
        this.loading = false;
        const msg = (res.data.message) ? res.data.message : 'Error on load products';
        const snackbar = { text: msg }
        if (!Array.isArray(res.data.payload)) {
          Object.assign(snackbar, {color: 'warning'})
          productionBus.$emit('open_snackbar', snackbar )
          return false;
        }
        console.log("result getProductList", res);
        if(res.data.payload.length == 0) {
          Object.assign(snackbar, {color: 'warning'})
          productionBus.$emit('open_snackbar', snackbar )
          return
        }
        this.products = res.data.payload;
        Object.assign(snackbar, {color: 'blue-grey'})
        productionBus.$emit('open_snackbar', snackbar )
      });
      this.$emit("close_filter_panel");
    },
    moveUrls() {
      this.loading = true;
      const properties = {
        task: 'moveUrls',
        payload: {
          product_ids: {
            from: this.$store.state.productionModule.selected_product.id,
            to: this.selected_product[0].product_id,
          },
          urls: this.selected_urls_of_product,
        }
      }
      this.$store
          .dispatch("productionModule/general_api", properties)
          .then((res) => {
            console.log("moveUrls results", res.data);
            this.loading = false;
            this.selected_urls_of_product = []
            this.selected_product = [];
            this.$emit('closeMoveDialog');
          }).catch(err => {
            console.log('moveUrls Error', err);
            this.$emit('snackbar', err.message);
          });
    },
    get_selected(type, value) {
      if (!!this.selected_client) {
        const payload = {
          task: "getProductFilter",
          payload: {
            brand_selection: this.selected.brand,
            client_selection: this.selected_client,
            domain_selection: this.selected_domains,
            ean_selection: this.selected.ean,
            filterTarget: `${type == "product" ? "name" : type}Filter`,
            name_selection: this.selected.product,
            seller_selection: this.selected_sellers,
            sku_selection: this.selected.sku !== 0 ? this.selected.sku : "",
            product_name: this.selected.product,
            brand_id: this.selected.brand,
            sku: this.selected.sku !== 0 ? this.selected.sku : "",
          },
        };
        // console.log('payload', payload);
        this.$store
          .dispatch("productionModule/general_api", payload)
          .then((res) => {
            console.log("go for " + type, res.data);
            this.results[`${type}`] = res.data;
            console.log("done result." + type, this.results[type]);
          });
      }
    },
  },
  watch: {
    // selected(newSelected, oldSelected) {
    //   console.log('selected.brand old' , oldSelected)
    //   console.log('selected.brand new' , newSelected)
    // }
    "selected.brand"(newValue) {
      if (newValue && newValue.length > 2) {
        this.get_selected("brand", newValue);
        // this.stored_brand = newValue;
      }
    },
    "selected.category"(newValue) {
      if (newValue && newValue.length > 2) {
        this.get_selected("category", newValue);
        // this.stored_category = newValue;
      }
    },
    "selected.product"(newValue) {
      if (newValue && newValue.length > 2) {
        this.get_selected("product", newValue);
        // this.stored_product = newValue;
      }
    },
    "selected.sku"(newValue) {
      if (newValue && newValue.length > 2) {
        this.get_selected("sku", newValue);
        // this.stored_sku = newValue;
      }
    },
    "selected.ean"(newValue) {
      if (newValue && newValue.length > 2) {
        this.get_selected("ean", newValue);
        // this.stored_ean = newValue;
      }
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/production/N_MoveUrls.vue